import { useState } from 'react';

interface DownloadButtonProps {
  bookId: string;
}

export function DownloadButton({ bookId }: DownloadButtonProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleDownload() {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`/api/book/${bookId}/download`, { credentials: 'include' });
      if (!res.ok) throw new Error('Download failed');
      const { url } = await res.json();
      window.open(url, '_self');
    } catch {
      setError('Download failed. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <button
        onClick={handleDownload}
        disabled={loading}
        aria-busy={loading}
        className="inline-flex items-center justify-center gap-2 rounded-button px-6 py-3 text-sm font-semibold bg-primary text-primary-foreground hover:bg-primary/90 transition-colors duration-80 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none w-full sm:w-auto"
      >
        {loading ? 'Preparing download…' : 'Download KDP Package'}
      </button>
      <p className="text-xs text-muted-foreground mt-2">
        Everything you need to publish
      </p>
      {error && <p className="text-xs text-destructive mt-1" role="alert">{error}</p>}
    </div>
  );
}
